function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { WDHComponent, resolveTemplate } from '../../../../wdh-foundation/wdh';
import fetchFactory from './fetch';
import ShoppingCart from './shopping-cart';
import OrderForm from './order-form';
import Product from './product';

/**
 * @module wdh-product-order
 */
var WDHProductOrder = /*#__PURE__*/function (_WDHComponent) {
  /**
     * @param className
     * @constructor
     * @augments WDHComponent
     * @inheritDoc
     */
  function WDHProductOrder() {
    var _this;
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'product-order';
    _classCallCheck(this, WDHProductOrder);
    _this = _callSuper(this, WDHProductOrder, [className]);
    _this.showSectionClass = 'show';
    _this.showErrorClass = 'show';
    _this.products = {};
    _this.shoppingCart = new ShoppingCart();
    _this.productReviewTemplate = null;
    _this.orderForm = {};
    _this.sectionOne = null;
    _this.sectionTwo = null;
    fetchFactory(window);
    return _this;
  }

  /**
     * Set up class variables and call specific section init methods
     * @param component
     */
  _inherits(WDHProductOrder, _WDHComponent);
  return _createClass(WDHProductOrder, [{
    key: "init",
    value: function init(component) {
      var _this2 = this;
      // Initialize some required attributes of the class
      this.sectionOne = component.querySelector('.section-one');
      this.sectionTwo = component.querySelector('.section-two');
      this.productReviewTemplate = component.querySelector('.product-review-template').innerHTML;
      // Add the form fields to the OrderForm object
      this.orderForm = new OrderForm(this.sectionOne.querySelectorAll('.product-form__form > label > input'));
      this.sectionOne.classList.add(this.showSectionClass); // Show by default section one

      // Parse all the products of a product group
      this.sectionOne.querySelectorAll('.product-order__products > .product').forEach(function (product) {
        // Fill the product class
        _this2.products[product.getAttribute('data-product-id')] = new Product(product);
      });

      //postal code hidden for oticon-DE, style variation added in sitecore
      if (component.classList.contains('hide-postalcode')) {
        component.querySelectorAll('.postnr').forEach(function (element) {
          element.style.display = 'none';
        });
        component.querySelector("input[name=PostalCode]").required = false;
        component.querySelector("input[name=PostalCode]").value = 0;
      }
      this.initSectionOne();
      this.initSectionTwo(component);
    }

    /**
       * Initializes specific section two events, including the last submit
       *
       * @param component Each instance of the current component
       */
  }, {
    key: "initSectionTwo",
    value: function initSectionTwo(component) {
      var _this3 = this;
      // Attach events to the edit buttons on the section-two
      this.sectionTwo.querySelectorAll('.form-summary__edit > input, .edit-order > input').forEach(function (element) {
        element.addEventListener('click', function () {
          // Show section one
          _this3.changeSection(_this3.sectionOne);
        });
      });

      // IMPORTANT THE SUBMIT IS HERE

      var loader = this.createLoader();
      this.sectionTwo.querySelector('.section-two__submit > input').addEventListener('click', function () {
        // Remove the error messages
        _this3.sectionTwo.querySelector('.accept-tos .error-message').classList.remove(_this3.showErrorClass);
        if (_this3.sectionTwo.querySelector('.accept-tos__checkbox > input').checked) {
          var url = component.getAttribute('data-endpoint');
          var payload = _this3.orderForm.getFieldsValues();
          payload.productDetails = _this3.shoppingCart.getFormattedProducts();
          _this3.sectionTwo.querySelector('.error-message.submit-error').parentNode.insertBefore(loader, _this3.sectionTwo.querySelector('.error-message.submit-error'));
          _this3.sectionTwo.querySelector('.section-two__submit > input').classList.add('disabled');
          _this3.sendPayload(payload, url); // The redirect happens in the payload
        } else {
          _this3.sectionTwo.querySelector('.accept-tos .error-message').classList.add(_this3.showErrorClass);
          _this3.sectionTwo.querySelector('.accept-tos .error-message').scrollIntoView({
            behavior: 'smooth'
          });
        }
      });
    }
  }, {
    key: "createLoader",
    value: function createLoader() {
      var loader = document.createElement('div'),
        loaderElement1 = document.createElement('div'),
        loaderElement2 = document.createElement('div'),
        loaderElement3 = document.createElement('div'),
        loaderElement4 = document.createElement('div');
      loader.append(loaderElement1, loaderElement2, loaderElement3, loaderElement4);
      loader.classList.add('loader');
      return loader;
    }
  }, {
    key: "hideLoader",
    value: function hideLoader() {
      if (this.sectionTwo.querySelector('.section-two__submit .loader')) {
        this.sectionTwo.querySelector('.section-two__submit > input').classList.remove('disabled');
        this.sectionTwo.querySelector('.section-two__submit .loader').remove();
      }
    }

    /**
       * Initializes the section one specific events and behavior
       */
  }, {
    key: "initSectionOne",
    value: function initSectionOne() {
      var _this4 = this;
      var sectionOneSubmit = this.sectionOne.querySelector('.section-one__submit > input');
      var sectionTwoHeader = this.sectionTwo.querySelector('.review-products__header');
      sectionOneSubmit.addEventListener('click', function () {
        // First we add product to the cart, so we don't have to go through them again later
        _this4.shoppingCart.clearCart();
        Object.keys(_this4.products).forEach(function (productId) {
          var product = _this4.products[productId];
          if (product.getSelectedAmount(productId) > 0) {
            _this4.shoppingCart.addProduct(product);
          }
        });
        if (_this4.validateSectionOne()) {
          // Add the products to the shoppingCart
          _this4.prepareSectionTwo(_this4.sectionTwo);
          // Finally show section two
          _this4.changeSection(_this4.sectionTwo);
          window.scrollTo(0, sectionTwoHeader.offsetTop);
        }
      });
    }

    /**
       * Sends the payload to the backend and redirects to the returned URL
       *
       * @param {{}} payload Object containing the required information for the payload
       * @param {string} url URL pointing to the endpoint where the payload needs to be send
       */
  }, {
    key: "sendPayload",
    value: function sendPayload(payload, url) {
      var _this5 = this;
      // Hide the error messages.
      this.sectionTwo.querySelector('.error-message.submit-error').classList.remove(this.showErrorClass);
      window.fetch(url, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: new Headers({
          'Content-Type': 'application/json'
        })
      }).then(function (response) {
        return response.json();
      }).catch(function (error) {
        // Also show the error message if there is an error in the request
        _this5.sectionTwo.querySelector('.error-message.submit-error').classList.add(_this5.showErrorClass);
        _this5.hideLoader();
        if (error) {
          // This is for debug purposes
          console.log(error); // eslint-disable-line no-console
        }
      }).then(function (responseData) {
        _this5.hideLoader();
        if (responseData && responseData.ConfirmationPageUrl && responseData.ConfirmationPageUrl !== '') {
          window.location.href = responseData.ConfirmationPageUrl;
        } else {
          _this5.sectionTwo.querySelector('.error-message.submit-error').classList.add(_this5.showErrorClass);
          if (responseData.ErrorMessage !== '') {
            // This is for debug purposes
            console.log(responseData.ErrorMessage); // eslint-disable-line no-console
          }
        }
      });
    }

    /**
       * Prepares section one to show.
       * NOTE: This is only used when coming from another section, not when the page loads
       */
  }, {
    key: "prepareSectionOne",
    value: function prepareSectionOne() {
      var _this6 = this;
      // Update the product amount with the cart state
      Object.keys(this.products).forEach(function (productId) {
        var cartProductAmount = _this6.shoppingCart.getProductAmount(productId);
        if (cartProductAmount !== false) {
          _this6.products[productId].setSelectedAmount(cartProductAmount);
        } else {
          _this6.products[productId].resetSelectedAmount();
        }
      });
    }
    /**
       * Validates the section one and adds the corresponding error message
       *
       * @returns {boolean} True if the section is valid, or false if is not
       */
  }, {
    key: "validateSectionOne",
    value: function validateSectionOne() {
      var _this7 = this;
      var isValid = true;

      // Clear the error messages
      this.sectionOne.querySelectorAll('.error-message').forEach(function (element) {
        element.classList.remove(_this7.showErrorClass);
      });

      // First the product list, checking that there is at least one product.
      if (!Object.keys(this.shoppingCart.getProductList()).length) {
        this.sectionOne.querySelector('.product-grid .error-message').classList.add(this.showErrorClass);
        isValid = false;
      }

      // Then the product form
      if (!this.orderForm.validateFields()) {
        this.sectionOne.querySelector('.product-form .error-message').classList.add(this.showErrorClass);
        isValid = false;
      }

      // Validate postal code
      if (document.querySelector('.postal-code-validation')) {
        if (!this.validatePostalCode()) {
          isValid = false;
        }
      }

      // Scroll the page to the first error
      var firstErrorMessage = this.sectionOne.querySelectorAll(".error-message.".concat(this.showErrorClass))[0];
      if (firstErrorMessage && firstErrorMessage !== '') {
        var stickyHeader = document.querySelector('.sticky-navigation');
        if (stickyHeader) firstErrorMessage = firstErrorMessage.offsetTop - stickyHeader.offsetHeight;else firstErrorMessage = firstErrorMessage.offsetTop;
        window.scrollTo(0, firstErrorMessage);
      }
      return isValid;
    }
  }, {
    key: "validatePostalCode",
    value: function validatePostalCode() {
      var regExp = /[a-zA-Z]/g;
      var postalCodeInput = Array.from(this.orderForm.inputFields).find(function (element) {
        return element.name === 'PostalCode';
      });
      var errorMessage = this.sectionOne.querySelector('.error-message.postal-code');
      var isValid = true;
      if (errorMessage) {
        if (postalCodeInput.value && regExp.test(postalCodeInput.value)) {
          postalCodeInput.classList.add('error');
          errorMessage.classList.add(this.showErrorClass);
          isValid = false;
        } else if (!postalCodeInput.value) {
          postalCodeInput.classList.add('error');
          errorMessage.classList.remove(this.showErrorClass);
          isValid = false;
        } else {
          postalCodeInput.classList.remove('error');
          errorMessage.classList.remove(this.showErrorClass);
        }
      }
      return isValid;
    }

    /**
       * Prepares the section two with the correct information to show
       */
  }, {
    key: "prepareSectionTwo",
    value: function prepareSectionTwo() {
      var _this8 = this;
      // Use cart items to fill the overview section
      var reviewTable = this.sectionTwo.querySelector('.review-products__table');
      var reviewForm = this.sectionTwo.querySelector('.form-summary__fields');

      // Hide the error message
      this.sectionTwo.querySelectorAll('.error-message').forEach(function (element) {
        element.classList.remove(_this8.showErrorClass);
      });
      reviewTable.innerHTML = ''; // Empty the inner html

      var shoppingCart = this.shoppingCart.getProductList();
      Object.keys(shoppingCart).forEach(function (productId) {
        // Add to the
        var product = _this8.products[productId];
        var options = {
          name: product.name,
          image: product.image,
          description: product.description,
          id: product.id,
          amount: shoppingCart[productId][0] || shoppingCart[productId]
        };
        var template = _this8.productReviewTemplate;
        reviewTable.innerHTML += resolveTemplate(template, options);
      });
      // Attach event for the REMOVE button
      reviewTable.querySelectorAll('.review-product__delete').forEach(function (element) {
        element.addEventListener('click', function () {
          var productId = element.parentElement.getAttribute('data-product-id');
          console.log('click', productId);
          if (productId) {
            // First remove the item from the shoppingCart
            var updatedProductList = _this8.shoppingCart.removeProduct(productId);
            // Check if is the last product, and redirect to page 1
            if (Object.getOwnPropertyNames(updatedProductList).length === 0) {
              _this8.prepareSectionOne();
              _this8.changeSection(_this8.sectionOne);
            }

            // Then remove the DOM element
            element.parentElement.outerHTML = '';
          }
        });
      });

      // Now fill the review form
      var fieldValues = this.orderForm.getFieldsValues(true);
      Object.keys(fieldValues).forEach(function (fieldName) {
        var selectedValue = reviewForm.querySelector(".".concat(fieldName, " .selected-value"));
        if (selectedValue) {
          selectedValue.innerHTML = fieldValues[fieldName];
        }
      });
    }

    /**
       * Adds the @_showSectionClass to the given @section and removes it from the other sections.
       *
       * @param {Element} section Element matching the section to change to.
       */
  }, {
    key: "changeSection",
    value: function changeSection(section) {
      switch (section) {
        case this.sectionOne:
          this.sectionOne.classList.add(this.showSectionClass);
          this.sectionTwo.classList.remove(this.showSectionClass);
          break;
        case this.sectionTwo:
          this.sectionOne.classList.remove(this.showSectionClass);
          this.sectionTwo.classList.add(this.showSectionClass);
          break;
        default:
          // console.log('Invalid section: ', section); // Enable this to debug
          break;
      }
    }
  }]);
}(WDHComponent);
export default WDHProductOrder;